<template>
  <div class="home">
    <el-card>
      <div class="card">
        <div>
          <span>rid :</span>
          <el-input
            v-model="rid"
            class="wid"
            type="textarea"
            :rows="2"
            placeholder="请输入rid"
          ></el-input>
          <p>ps:输入多个 rid 用英文逗号分隔</p>
        </div>
        <div>
          <span>title :</span>
          <el-input
            v-model="title"
            class="wid"
            placeholder="请输入title"
          ></el-input>
        </div>
        <div>
          <span>body :</span>
          <el-input
            v-model="body"
            class="wid"
            type="textarea"
            :rows="2"
            placeholder="请输入body"
          ></el-input>
        </div>
        <div>
          <span></span>
          <el-button @click="push" class="wid" type="primary">推送</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      body: '',
      rid: '',
      title: ''
    }
  },

  async created () {},
  methods: {
    async push () {
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.sender_fcm +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,

        {
          body: this.body,
          rid: this.rid,
          title: this.title
        }
      )
      if (res.code != 0) return this.$message('失败')
      this.$message.success('成功')
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  padding: 20px 20px 0;
  .wid {
    width: 500px;
  }
  .card {
    > div {
      display: flex;
      align-items: center;
      margin: 0 20px 10px;
      > span {
        width: 100px;
        margin: 0 20px;
      }
      > p {
        margin: 0 20px;
      }
    }
  }
}
</style>
